import { DashboardActionType, SET_DASHBOARD_DATA } from "../types/actions/Dashboard.actions";

type InitialState = {
	data: any | null
}

const initialState: InitialState = {
	data: null,
}

const dashboardReducer = (state = initialState, action: DashboardActionType) => {
	switch (action.type) {
		case SET_DASHBOARD_DATA:
			return {
				...state,
				data: action.payload
			}
		default:
			return state;
  	}
};

export default dashboardReducer;
